import React from "react";
import styled from "styled-components";

export const Container = styled.div`
	margin: ${props => props.theme.spacing};
	max-width: ${props => props.theme.max};
    @media(max-width: 767px){
		margin:  ${(props) => props.theme.mobileSpacing};
	}
`;

export const Content = styled.div`
    margin-top: 10px;    
    p {
        color: #212323;
        font-family: Mallory;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 0;
        line-height: 28px;
    }
`;

export const Header = styled.h4`
    color: #050505;
    font-family: Mallory;
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 1px;
    line-height: 22px;  
    margin-bottom: 0;
`;

export const Flex = styled.div`
   @media (min-width: 767px){ 
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    max-width: 923px;
   }
   margin: auto;
`;
export const LeftCol = styled.div`
    flex: 0 1 65%;
    @media (max-width: 767px){
        margin: 0 18px;
    }
`;
export const RightCol = styled.div`
    border-left: solid 1px #EFEDEB;
    padding-left: 35px;
    margin-left: 78px;
    max-width: 175px;
    @media (max-width: 767px){
        display: block;
        margin: auto;
        max-width: 176px;
        border: none;
        padding: 0;
    }
`;

export const ProductImage = styled.img`
    width: 175px;
    height: auto;
    @media (max-width: 767px){
        margin: auto;
    }
`;

export const ProductBrand = styled.p`
    color: #999999;
    font-family: Mallory;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 12px;
    padding-left: 14px;
    margin-bottom: 4px;
    text-transform: uppercase;
    @media (max-width: 767px){
        margin-top: 8px;
    }
`;

export const ProductTitle = styled.p`
    color: #070808;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 16px;
    padding-left: 14px;
    margin-top: 0;
`;

export const ProductPrice = styled.p`
    color: #747474;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 17px;
    padding-left: 14px;
    margin-bottom: 10px;
    @media (max-width: 767px){
        margin-bottom: 16px;
    }
`;

export const ShopNow = styled.a`
    height: 40px;
    width: 176px;
    background-color: #070808;
    color: #FFFFFF;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 40px;
    text-align: center;  
    display: block;
    text-decoration: none;
    border: 1px solid rgb(7, 8, 8);
    &:hover {
        background-color: rgb(255, 255, 255);
        color: rgb(7, 8, 8);
        border: 1px solid rgb(7, 8, 8);
    }
`;